var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricesBtc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#f7931a",
    height: 40,
    rx: 20,
    width: 40,
    y: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.9863 17.5255c.3925-2.62-1.6038-4.0288-4.3313-4.9688l.885-3.54996-2.16-.5375-.8625 3.45626c-.5675-.1425-1.15-.275-1.7312-.4075l.8687-3.47876-2.16-.53875-.885 3.54871c-.47-.1075-.9325-.2125-1.38-.325l.0025-.0112-2.98-.74376-.575 2.30746s1.6038.3675 1.57.39c.875.2188 1.0325.7975 1.0063 1.2575l-1.0075 4.0438c.06.015.1375.0375.225.0712l-.2288-.0562-1.4125 5.665c-.1075.265-.3787.6637-.9912.5125.0225.0312-1.57-.3913-1.57-.3913l-1.0725 2.4725 2.8125.7013c.5225.1312 1.035.2687 1.5387.3975l-.8937 3.59 2.1587.5375.885-3.55c.59.1587 1.1625.3062 1.7225.4462l-.8825 3.535 2.16.5375.8938-3.5825c3.685.6975 6.455.4163 7.6212-2.9162.94-2.6825-.0462-4.2313-1.985-5.24 1.4125-.325 2.475-1.2538 2.7588-3.1725zm-4.9375 6.9225c-.6663 2.6837-5.185 1.2325-6.65.8687l1.1875-4.7562c1.465.3662 6.1612 1.09 5.4625 3.8875zm.6687-6.9613c-.6087 2.4413-4.3687 1.2-5.5875.8963l1.075-4.3125c1.2188.3037 5.1475.87 4.5125 3.4162z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricesBtc);
export default __webpack_public_path__ + "static/media/prices-btc.0b92dbaec350e68acced5e182299d2c7.svg";
export { ForwardRef as ReactComponent };